import script from "./updateSearchList.vue?vue&type=script&setup=true&name=updateSearchList&lang=js"
export * from "./updateSearchList.vue?vue&type=script&setup=true&name=updateSearchList&lang=js"

const __exports__ = script;

export default __exports__